import { Component, OnInit } from "@angular/core";
import { AppService } from "../../../app.service";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})

export class NewsComponent implements OnInit {
   selectedLanguage = "";

  font = "";
  ContentData: any;
  News_event_data: any;
  foundnews: any;

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    // this.selectedLanguage = localStorage.getItem('selectedLanguage');

    this.FetchData();
  }
    // Test truncate starts
    truncateText(text, maxLength) {
        // Check if the text length is greater than the maximum length
        if (text.length > maxLength) {
            // Truncate the text to the maximum length and append "..." at the end
            return text.substring(0, maxLength) + "...";
        } else {
            // If the text length is within the maximum length, return the original text
            return text;
        }
    }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "response FetchData");

      this.ContentData = response.data;
      console.log(this.ContentData, "Default Content Data");

      if (this.ContentData != null) {
        let news = this.ContentData.filter(
          (x) => x.ContentCategoryName == "News And Events"
        );
        news.sort((a: any, b: any) => b.Id - a.Id);
        this.News_event_data = news;
        // this.foundnews = this.News_event_data.ShowAttachments;
        console.log(this.News_event_data, "All News Event Data");
      }
    });
  }

  GetFontName() {
    switch (this.selectedLanguage) {
      case "en":
        return "Congenial";
      case "bn":
        return "Kalpurush";
      case "ar":
        return "Jameel Noori Nastaleeq";
    }
  }

  stripHtml(html: string) {
    if (!html) return '';
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

}
